import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import AddToCalendar from 'hb-react/frontoffice/components/AddToCalendar';
import { AttendeesRow } from 'hb-react/shared/apps/Events/components/AttendeesRow';
import { Calendar } from 'hb-react/shared/apps/Events/components/Calendar';
import { EventWebinarUrl } from 'hb-react/shared/apps/Events/components/EventDetailsContainer/components/EventWebinarUrl';
import { useEventContext } from 'hb-react/shared/apps/Events/contexts/EventContext';
import useEventDisplayTimeZone from 'hb-react/shared/components/EventDate/hooks/useEventDisplayTimeZone';
import getDateStr from 'hb-react/shared/components/EventDate/utils/getDateStr';

const EventSummary = () => {
  const { event } = useEventContext();
  const {
    venue,
    start_date: startDate,
    end_date: endDate,
    title,
    locations,
    show_webinar_url: showWebinarUrl,
    webinar_url: webinarUrl,
    timezone: eventTimeZone,
    display_add_to_calendar: displayAddToCalendar,
  } = event;

  const eventDisplayTimeZone = useEventDisplayTimeZone(eventTimeZone);

  const address = locations?.address ?? '';

  const dateStr = getDateStr({
    startDate,
    endDate,
    timezone: eventDisplayTimeZone,
  });

  return (
    <Box flexDirection="column">
      <Box>
        <Calendar
          startDate={startDate}
          eventDisplayTimeZone={eventDisplayTimeZone}
        />

        <EventTitle>{title}</EventTitle>
      </Box>

      <Box
        font="body-semibold-black"
        flexDirection="column"
        gridRowGap={2}
        mt={4}
        minWidth={0}
      >
        <time>{dateStr}</time>
        {venue && <span>{venue}</span>}
        {address && <address>{address}</address>}

        {webinarUrl && (
          <EventWebinarUrl
            webinar_url={webinarUrl}
            show_webinar_url={showWebinarUrl}
            ml={0}
          >
            <Box mr={1} font="body-semibold-black" flexShrink={0}>
              {`${__('Online event')}${showWebinarUrl ? ':' : ''}`}
            </Box>
          </EventWebinarUrl>
        )}
        {displayAddToCalendar && (
          <AddToCalendar
            id={event.id}
            timezone={eventTimeZone}
            eventType={event.type}
          />
        )}
      </Box>

      <AttendeesRow event={event} mt={6} />
    </Box>
  );
};

export default EventSummary;

const EventTitle = styled(Box).attrs(() => ({
  as: 'h1',
  'data-testid': 'event-title',
  pl: 3,
  font: 'h3-semibold',
  alignItems: 'center',
}))``;
